import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  approveRejectTickets,
  fetchCurrentChallenger,
  fetchCurrentChampion
} from '../../../redux/actions/trm/trmDashboard';
import { bindActionCreators } from 'redux';
import TicketDetails from './TicketDetail';
import { fetchAMLSAlertLevel } from '../../../redux/actions/common';

/**
 *
 * @param state
 * @param ownProps
 * @returns {{}}
 */
const mapStateToProps = (state) => ({
  trmDashboard: state.trmDashboard,
  alertLevels: state.amlsCommon.alertLevelConfigs?.data
});

/**
 *
 * @param dispatch
 * @param ownProps
 * @returns {{}}
 */
const mapDispatchToProps = (dispatch) => ({
  apiActions: bindActionCreators(
    {
      fetchCurrentChallenger,
      fetchCurrentChampion,
      approveRejectTickets,
      fetchAMLSAlertLevel
    },
    dispatch
  )
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TicketDetails)
);
